import { InformationComponent } from './../information/information.component';
import { DepartementMapper } from '../../../../models/enums/zone-geographique.enum';
import { PresseSpecialiseService } from './../../services/presse-specialise.service';
import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PresseMessages } from '../../models/component-messages/presse-messages';
import { ZoneGeographiqueEnum } from '../../../../models/enums/zone-geographique.enum';
import { map, takeUntil } from 'rxjs/operators';
import { Diffuseur } from '../../../../models/diffuseur';

@Component({
  selector: 'app-presse-specialise',
  templateUrl: './presse-specialise.component.html',
  styleUrls: ['./presse-specialise.component.scss']
})
export class PresseSpecialiseComponent implements OnInit, OnDestroy {

  @Input() mode: number;
  @Input() id: number;
  @Output() presseOutput: EventEmitter<Diffuseur> = new EventEmitter();

  private unsubscribe$ = new Subject<void>();

  public form: FormGroup;

  public presseMessages = new PresseMessages();

  public enumZoneGeographique = ZoneGeographiqueEnum;
  public optionsSelect: any[] = [];

  constructor(private presseService: PresseSpecialiseService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.form = new FormGroup({});
    this.initOptions();
    if (this.mode === 2) {
      this.getPresse();
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  initOptions(): void {
    const keys: string[] = Object.keys(this.enumZoneGeographique).filter((item) => {
      return !isNaN(Number(item));
    });
    keys.forEach(key => {
      this.optionsSelect.push({
        "code": this.enumZoneGeographique[key],
        "libelle": DepartementMapper.getIntitule(this.enumZoneGeographique[key])
      })
    });
  }

  getPresse(): void {
    this.presseService.getByIdPresse(this.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.form.get("intitule")?.setValue(data.intitule);
          this.form.get("contact")?.setValue(data.contact);
          this.form.get("email")?.setValue(data.email);
          this.form.get("telephone")?.setValue(data.telephone);
          this.form.get("departement")?.setValue(data.zoneGeographique);
        })
      });
  }

  valider(): void {
    const presseSpecialise: Diffuseur = new Diffuseur;
    presseSpecialise.intitule = this.form.get("intitule")?.value;
    presseSpecialise.email = this.form.get("email")?.value;
    presseSpecialise.contact = this.form.get("contact")?.value;
    presseSpecialise.telephone = this.form.get("telephone")?.value;
    presseSpecialise.zoneGeographique = this.form.get("departement")?.value;

    //création
    if (this.mode === 1) {
      const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = '';
      modalRef.componentInstance.content = this.presseMessages.modal_create_text;
      modalRef.componentInstance.OkOuRetour = true;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.presseService.createPresse(presseSpecialise)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: ((data) => {
                    this.presseOutput.emit(data);
                    this.exitModal();
                  })
                });
            }
          })
        })
    }

    //modification
    if (this.mode === 2) {
      presseSpecialise.id = this.id;
      const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = '';
      modalRef.componentInstance.content = this.presseMessages.modal_update_text;
      modalRef.componentInstance.OkOuRetour = true;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.presseService.updatePresse(presseSpecialise)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: ((data) => {
                    this.presseOutput.emit(data);
                    this.exitModal();
                  })
                });
            }
          })
        })
    }
  }

  delete(): void {
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.content = this.presseMessages.modal_delete_text;
    modalRef.componentInstance.OkOuRetour = true;
    modalRef.dismissed.pipe(map((reason: boolean) => {
      return reason;
    }))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((reason) => {
          if (reason) {
            this.presseService.deletePresse(this.id)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe({
                next: (() => {
                  const presseOutput: Diffuseur = new Diffuseur();
                  presseOutput.id = this.id;
                  this.presseOutput.emit(presseOutput);
                  this.exitModal();
                })
              });
          }
        })
      })

  }

  exitModal(): void {
    this.modalService.dismissAll();
  }

}
